import request from "@/utils/request";

// 通过id查询数据
export function queryReflectionByPlantId(plantsId) {
  return request({
    url: "/opPlantsHkNameConfig/page",
    method: "post",
    data: {
      plantsId,
    },
  });
}

// 新增
export function insertReflection(data) {
  return request({
    url: "/opPlantsHkNameConfig/save",
    method: "post",
    data,
  });
}

// 编辑
export function updateReflection(data) {
  return request({
    url: "/opPlantsHkNameConfig/update",
    method: "post",
    data,
  });
}
